export enum EventFrequency {
  Continuous = 'continuous',
  Weekly = 'weekly',
  Custom = 'custom',
}
